var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgNoInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 674,
    height: 350,
    viewBox: "0 0 674 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2346_5419)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2346_5419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 674,
    height: 326
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M673.09 0H0V325.1H673.09V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2346_5419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241 88C241 81.92 236.06 77 229.96 77H132.04C125.94 77 121 81.92 121 88C121 94.08 125.94 99 132.04 99H105.04C98.94 99 94 103.92 94 110C94 116.08 98.94 121 105.04 121H123.46C117.36 121 112.42 125.92 112.42 132C112.42 138.08 117.36 143 123.46 143H221.38C227.48 143 232.42 138.08 232.42 132C232.42 125.92 227.48 121 221.38 121H202.96C209.06 121 214 116.08 214 110C214 103.92 209.06 99 202.96 99H229.96C236.06 99 241 94.08 241 88Z",
    fill: "#ACAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.96 99H181.03C174.93 99 169.99 103.92 169.99 110C169.99 116.08 174.93 121 181.03 121H278.96C285.06 121 290 116.08 290 110C290 103.92 285.06 99 278.96 99Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.96 99H36.04C29.94 99 25 103.92 25 110C25 116.08 29.94 121 36.04 121H133.97C140.07 121 145.01 116.08 145.01 110C145.01 103.92 140.07 99 133.97 99H133.96Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.21 29.3699C590.38 21.2499 564.95 35.7199 559.03 46.9199C553.11 58.1299 561.38 79.1999 577.66 94.8499C593.94 110.5 574.18 121.58 567.17 113C560.16 104.41 554.2 71.4599 540.14 84.7399C526.08 98.0199 530.87 113.72 557.18 132.37C583.5 151.02 526.5 118.58 521.46 132.37C516.42 146.16 535.77 170.06 558.52 174.92C558.52 174.92 563.85 203.64 601.63 200.3C639.4 196.96 660.52 168.58 625.72 159.23C590.92 149.88 595 144.68 602.38 142.44C609.77 140.2 656.06 140.2 655.73 123.41C655.39 106.62 616.49 121.17 613.88 115.58C611.28 110 660.97 110.17 663.57 94.8499C666.17 79.5399 670.83 40.5799 624.2 29.3699H624.21Z",
    fill: "url(#paint0_linear_2346_5419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.51 70.3899C616.51 70.3899 549.2 181.68 509 348.24",
    stroke: "url(#paint1_linear_2346_5419)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.16 258.59C390.26 251.95 379.04 232.23 372.26 220.66C376.51 213.25 381.69 205.61 387.96 197.78C388.35 197.3 388.75 196.84 389.13 196.36C403.2 221.2 423.04 254.75 414.47 230.25C407.12 209.16 404.31 192.21 403.23 181.58C408.46 176.88 413.89 172.75 419.4 169.11C424.86 188.68 431.68 210.79 434.01 212.87C438.07 216.53 441.8 216.53 437.57 201.88C435.01 193.05 434.26 174.19 434.07 160.64C441.54 156.91 449.08 153.94 456.49 151.56C456.41 157.66 456.55 164.4 457.28 169.86C459.11 183.58 463.21 193.18 469.14 193.18C473.39 193.18 471.54 164.16 470.14 147.82C475.7 146.53 481.13 145.59 486.29 144.86C487.14 154.71 488.98 166.14 492.83 166.65C497.37 167.25 498.1 153.14 498.07 143.59C519.16 141.97 533.86 144.22 533.86 144.22C533.86 144.22 539.17 158.79 541 181.03C531.46 181.91 520.91 183.76 520.41 187.48C519.85 191.75 532.21 192.66 541.6 192.73C541.71 199.35 541.48 206.45 540.73 213.88C524.16 213.96 497.28 214.59 497.53 218.04C497.89 223.01 507.67 225.74 521.43 226.26C526.76 226.45 533.23 226.12 539.14 225.62C537.98 232.28 536.37 239.17 534.19 246.13C521.37 248.27 505.42 250.44 497.16 249.67C482.05 248.23 482.75 251.9 487.1 255.23C489.41 257 509.6 259.41 528.74 261.14C525.72 268.26 522.54 274.57 519.27 280.19C508.63 281.08 493.19 281.36 474.05 278.94C449.51 275.84 482.13 287.06 508.77 295.57C496.26 311.06 483.29 318.11 472.61 321.11C462.78 313.99 451.61 306.29 446.92 304.39C443.36 302.95 445.4 311.38 449.31 322.25C448.91 322.15 448.69 322.1 448.69 322.1H360.4C360.4 322.1 346.02 290.02 360.4 246.84C376.24 255.4 393.71 263.87 392.19 258.52L392.15 258.56L392.17 258.6L392.16 258.59Z",
    fill: "url(#paint2_linear_2346_5419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.22 320.44C393.22 320.44 467.1 206.86 499.64 184.13",
    stroke: "url(#paint3_linear_2346_5419)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.02 319.16C626.56 316.24 633.57 309.16 633.57 309.16C633.57 309.16 621.02 307.27 615.06 309.16C615.06 309.16 631.69 291.21 629.49 286.17C627.29 281.12 604.07 302.66 604.07 302.66C604.07 302.66 613.17 262.55 610.03 261.6C606.9 260.65 593.71 292.14 593.71 292.14C593.71 292.14 585.24 238.28 581.47 239.55C577.7 240.82 576.45 297.49 578.64 302.85C578.64 302.85 557.3 284.58 554.8 286.16C552.29 287.74 570.18 317.65 574.56 320.49H618.27C618.27 320.49 619.96 319.72 621.02 319.16Z",
    fill: "url(#paint4_linear_2346_5419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.45 222.8C45.83 218.29 42.79 214.3 28.82 213.32C14.85 212.35 8.45997 194.87 21.71 184.75C34.96 174.64 48.52 175.4 50.3 183.62C52.08 191.84 46.01 195.68 46.8 202.13C47.59 208.59 52.44 189.09 57.9 189.44C63.36 189.79 69.88 192.6 65.21 204.05C60.54 215.5 55.68 214.85 55.65 218.24C55.62 221.63 61.84 227.08 63.73 221.57C65.62 216.07 66.34 202.07 70.99 201.77C75.63 201.46 89.04 229.08 71.54 243.11C54.04 257.14 42.54 261.6 37.26 251.8C31.98 241.99 47.25 242.47 52.41 238.61C57.57 234.76 34.07 237.04 29.98 229.95C25.89 222.87 44.96 228.65 45.44 222.78H45.46V222.8H45.45Z",
    fill: "url(#paint5_linear_2346_5419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.47 316.29C86.47 316.29 94.8 299.48 72.54 243.73",
    stroke: "#947E6D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.85 150.56C127.85 150.56 74.4 206.22 68.8 316.6",
    stroke: "#947E6D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.65 284.58C130.79 280.5 130.94 274.69 144.98 264.62C159.02 254.56 152.38 233.61 130.6 232.57C108.81 231.53 95.0501 241.13 99.4701 250.17C103.89 259.21 113.26 258.93 117.37 265.64C121.48 272.35 101.4 256.82 95.8901 260.73C90.3801 264.63 85.6301 271.59 99.3601 279.52C113.09 287.45 117.73 283.65 120.36 286.88C123 290.11 120.58 299.4 114.36 295.36C108.14 291.32 96.6401 278.37 91.4901 281.11C86.3401 283.85 93.3301 319.1 122.62 321.12C151.91 323.14 167.5 319.9 165.58 307.05C163.65 294.19 147.85 304.63 139.43 304.3C131.01 303.98 157.64 290.8 156.53 281.34C155.42 271.88 139.67 289.88 134.66 284.57V284.59H134.65V284.58Z",
    fill: "url(#paint6_linear_2346_5419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.48 138.87V270.78C464.48 276.5 459.84 281.14 454.12 281.14H325.36C319.64 281.14 315 276.5 315 270.78V87.38C315 81.66 319.64 77.02 325.36 77.02H389.74",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.48 161.03V270.78C464.48 276.5 459.84 281.14 454.12 281.14H325.36C319.64 281.14 315 276.5 315 270.78V87.38C315 81.66 319.64 77.02 325.36 77.02H374.91",
    stroke: "#9B7E63",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "20 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.74 77.01V128.5C389.74 134.22 394.38 138.86 400.1 138.86H461.7C462.64 138.86 463.06 137.69 462.34 137.09L389.75 77.01H389.74Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.93 201.64C355.79 202.18 354.48 204.35 355.02 206.49C355.56 208.63 357.73 209.94 359.87 209.4L357.93 201.64ZM385.25 203.06L389.13 202.09L387.19 194.33L383.31 195.3L385.25 203.06ZM359.87 209.4L385.25 203.06L383.31 195.3L357.93 201.64L359.87 209.4Z",
    fill: "#9B7E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.5 166.78C373.94 168.34 373.94 170.87 375.5 172.44C377.06 174 379.59 174 381.16 172.44L375.5 166.78ZM398.13 155.47C399.69 153.91 399.69 151.38 398.13 149.81C396.57 148.25 394.04 148.25 392.47 149.81L398.13 155.47ZM392.47 149.81L375.5 166.78L381.16 172.44L398.13 155.47L392.47 149.81Z",
    fill: "#9B7E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.16 149.81C379.6 148.25 377.07 148.25 375.5 149.81C373.94 151.37 373.94 153.9 375.5 155.47L381.16 149.81ZM392.47 172.44C394.03 174 396.56 174 398.13 172.44C399.69 170.88 399.69 168.35 398.13 166.78L392.47 172.44ZM398.13 166.78L381.16 149.81L375.5 155.47L392.47 172.44L398.13 166.78Z",
    fill: "#9B7E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.56 167.12C327 168.68 327 171.21 328.56 172.78C330.12 174.34 332.65 174.34 334.22 172.78L328.56 167.12ZM351.19 155.81C352.75 154.25 352.75 151.72 351.19 150.15C349.63 148.59 347.1 148.59 345.53 150.15L351.19 155.81ZM345.53 150.15L328.56 167.12L334.22 172.78L351.19 155.81L345.53 150.15Z",
    fill: "#9B7E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.22 150.15C332.66 148.59 330.13 148.59 328.56 150.15C327 151.71 327 154.24 328.56 155.81L334.22 150.15ZM345.53 172.78C347.09 174.34 349.62 174.34 351.19 172.78C352.75 171.22 352.75 168.69 351.19 167.12L345.53 172.78ZM351.19 167.12L334.22 150.15L328.56 155.81L345.53 172.78L351.19 167.12Z",
    fill: "#9B7E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.74 77.01V128.5C389.74 134.22 394.38 138.86 400.1 138.86H461.7C462.64 138.86 463.06 137.69 462.34 137.09L389.75 77.01H389.74Z",
    stroke: "#9B7E63",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "20 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.99 316.68H26.15C25.51 316.68 25 318.47 25 320.68V321.1C25 323.31 25.52 325.1 26.15 325.1H173.99C174.63 325.1 175.14 323.31 175.14 321.1V320.68C175.14 318.47 174.62 316.68 173.99 316.68Z",
    fill: "#9B7E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.48 316.68H205.47C203.48 316.68 201.86 318.47 201.86 320.68V321.1C201.86 323.31 203.48 325.1 205.47 325.1H669.48C671.47 325.1 673.09 323.31 673.09 321.1V320.68C673.09 318.47 671.47 316.68 669.48 316.68Z",
    fill: "#9B7E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.78 281.31C347.91 277.38 354.58 265.72 358.6 258.88C356.07 254.5 353 249.99 349.27 245.36C349.04 245.07 348.8 244.8 348.57 244.52C340.22 259.2 328.44 279.04 333.52 264.56C337.89 252.09 339.56 242.06 340.19 235.79C337.09 233.01 333.87 230.56 330.59 228.41C327.35 239.98 323.3 253.06 321.92 254.29C319.5 256.45 317.3 256.45 319.8 247.8C321.32 242.57 321.77 231.43 321.88 223.42C317.44 221.21 312.97 219.46 308.56 218.05C308.61 221.66 308.52 225.63 308.09 228.87C307.01 236.98 304.57 242.66 301.05 242.66C298.52 242.66 299.62 225.5 300.45 215.84C297.15 215.08 293.93 214.52 290.86 214.09C290.35 219.92 289.26 226.67 286.97 226.97C284.28 227.33 283.84 218.98 283.87 213.34C271.35 212.39 262.62 213.72 262.62 213.72C262.62 213.72 259.47 222.34 258.38 235.48C264.05 236.01 270.3 237.1 270.6 239.29C270.93 241.82 263.6 242.35 258.02 242.39C257.95 246.31 258.09 250.5 258.54 254.89C268.38 254.94 284.34 255.32 284.19 257.35C283.97 260.28 278.16 261.9 270 262.21C266.84 262.33 263 262.13 259.49 261.83C260.18 265.77 261.13 269.84 262.42 273.96C270.03 275.22 279.51 276.51 284.41 276.05C293.38 275.2 292.97 277.37 290.39 279.34C289.02 280.39 277.03 281.81 265.67 282.83C267.46 287.04 269.35 290.77 271.29 294.09C277.61 294.62 286.77 294.78 298.14 293.36C312.71 291.53 293.34 298.16 277.52 303.18C284.95 312.34 292.65 316.51 298.99 318.28C304.83 314.07 311.45 309.52 314.25 308.4C316.37 307.55 315.15 312.53 312.84 318.96C313.08 318.9 313.21 318.87 313.21 318.87H365.63C365.63 318.87 374.16 299.9 365.63 274.37C356.22 279.44 345.85 284.44 346.75 281.28L346.77 281.3H346.78V281.31Z",
    fill: "url(#paint7_linear_2346_5419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.52 321C347.52 321 302.19 250.58 282.88 237.13",
    stroke: "url(#paint8_linear_2346_5419)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.815 298.755L266.775 257.795C269.075 255.495 269.075 251.775 266.775 249.475L264.005 246.705C261.705 244.405 257.985 244.405 255.685 246.705L214.725 287.665C212.425 289.965 212.425 293.685 214.725 295.985L217.495 298.755C219.795 301.055 223.515 301.055 225.815 298.755Z",
    fill: "#9B7E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.745 169.115C319.925 146.295 282.935 146.295 260.115 169.115C237.295 191.935 237.295 228.925 260.115 251.745C282.935 274.565 319.925 274.565 342.745 251.745C365.565 228.925 365.565 191.935 342.745 169.115ZM332.805 241.805C315.475 259.135 287.385 259.135 270.055 241.805C252.725 224.475 252.725 196.385 270.055 179.055C287.385 161.725 315.475 161.725 332.805 179.055C350.135 196.385 350.135 224.475 332.805 241.805Z",
    fill: "#9B7E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.425 254.785C325.925 254.785 345.795 234.915 345.795 210.415C345.795 185.915 325.925 166.045 301.425 166.045C276.925 166.045 257.055 185.915 257.055 210.415C257.055 234.915 276.925 254.785 301.425 254.785Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.765 188.285C315.115 186.715 312.965 185.445 310.375 184.515C307.755 183.575 304.555 183.095 300.875 183.095C298.105 183.095 295.485 183.485 293.105 184.255C290.745 185.015 288.675 186.105 286.945 187.475C285.235 188.835 283.875 190.465 282.885 192.325C281.925 194.145 281.435 196.195 281.435 198.395C281.435 199.645 281.625 200.835 282.005 201.925C282.385 203.025 282.915 204.015 283.565 204.885C284.225 205.755 285.005 206.515 285.865 207.135C286.405 207.525 286.975 207.855 287.555 208.115C288.015 207.545 288.545 207.015 289.145 206.505C290.035 205.755 290.985 205.075 291.955 204.495C292.915 203.915 293.855 203.415 294.755 203.005C295.645 202.595 296.385 202.265 296.985 202.025C297.415 201.845 297.755 201.695 298.015 201.575C297.985 201.365 297.975 201.145 297.975 200.905C297.975 199.745 298.425 199.015 298.805 198.605C299.205 198.165 299.945 197.645 301.155 197.645C302.175 197.645 303.035 198.055 303.585 198.795C304.035 199.405 304.265 200.195 304.265 201.145C304.265 202.315 303.775 203.395 302.845 204.265C302.075 204.985 300.855 205.695 299.105 206.435C297.425 207.175 295.955 207.905 294.765 208.585C293.665 209.215 292.755 209.915 292.065 210.665C291.415 211.375 290.955 212.145 290.665 213.015C290.365 213.925 290.205 215.025 290.205 216.295C290.205 217.335 290.405 218.265 290.785 219.075C291.205 219.945 291.715 220.705 292.315 221.315C292.845 221.855 292.895 222.705 292.445 223.315C291.855 224.105 291.395 224.995 291.075 225.965C290.755 226.935 290.595 227.995 290.595 229.125C290.595 230.405 290.855 231.635 291.375 232.765C291.905 233.925 292.615 234.945 293.505 235.795C294.395 236.655 295.455 237.345 296.655 237.855C299.045 238.865 301.985 238.845 304.385 237.855C305.605 237.345 306.685 236.655 307.595 235.795C308.495 234.945 309.215 233.925 309.745 232.775C310.265 231.645 310.525 230.415 310.525 229.135C310.525 227.995 310.345 226.915 309.995 225.925C309.635 224.925 309.145 224.015 308.535 223.225C307.925 222.435 307.195 221.755 306.345 221.205C305.485 220.645 304.525 220.205 303.505 219.905C302.845 219.715 302.395 219.105 302.395 218.425C302.395 217.345 302.745 216.565 303.445 216.105C304.545 215.375 306.055 215.435 308.055 216.345C308.765 216.665 309.455 217.095 310.115 217.615C310.675 217.315 311.265 216.965 311.875 216.585C312.805 216.005 313.745 215.315 314.665 214.525C315.585 213.735 316.485 212.845 317.325 211.865C318.155 210.895 318.905 209.815 319.555 208.635C320.195 207.475 320.715 206.185 321.095 204.815C321.465 203.455 321.655 201.965 321.655 200.385C321.655 198.065 321.245 195.835 320.445 193.755C319.655 191.715 318.425 189.885 316.775 188.325V188.285H316.765Z",
    fill: "#927D6D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2346_5419",
    x1: 561.64,
    y1: 178.29,
    x2: 660.61,
    y2: 13.4099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B8A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743B1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2346_5419",
    x1: 547.3,
    y1: 238.8,
    x2: 620.44,
    y2: 74.1499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#947E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D6C0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2346_5419",
    x1: 488.49,
    y1: 143.63,
    x2: 417.27,
    y2: 322.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#93C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#496F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2346_5419",
    x1: 416,
    y1: 291.86,
    x2: 503.37,
    y2: 172.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#9AC276"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2346_5419",
    x1: 597.68,
    y1: 319.88,
    x2: 584.26,
    y2: 238.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB6D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA9C78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2346_5419",
    x1: 11.11,
    y1: 202.01,
    x2: 78.62,
    y2: 233.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EA9C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2346_5419",
    x1: 142.5,
    y1: 225.4,
    x2: 121.6,
    y2: 317.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#94C366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2346_5419",
    x1: 303.36,
    y1: 261.85,
    x2: 349.48,
    y2: 318.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BA757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2346_5419",
    x1: 332.35,
    y1: 301.11,
    x2: 280.51,
    y2: 230.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#9AC276"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2346_5419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 673.09,
    height: 349.74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNoInfo);
export default __webpack_public_path__ + "static/media/img-no-info.26b29eb82b73eaa940352eeb39886384.svg";
export { ForwardRef as ReactComponent };